import { LoadingIndicator } from '../loading-indicator/loading-indicator';
import { addClass } from '@opten/dom/add-class';
import { hasClass } from '@opten/dom/has-class';

export default class LoadContentBase {

    loadingIndicator: string;
    contentElement: HTMLElement;
    formElementWrapper: HTMLElement;
    targetToLoad: string;
    language: string;
    formElement: HTMLFormElement;
	contentLoaded = false;

    constructor(element: HTMLElement) {
        this.loadingIndicator = new LoadingIndicator().contentLoading;
        this.contentElement = element;
		if (this.contentElement) {
			this.init();
		}
    }

    init() {
        this.targetToLoad = this.contentElement.getAttribute('data-load');
        var dataLanguage = document.body.getAttribute('data-language-long');
        if (dataLanguage && dataLanguage.length > 0) {
            this.language = dataLanguage;
        }
		if(hasClass(this.contentElement,'loaded--content') == false){
			this.contentElement.innerHTML = this.loadingIndicator;
		}
		else{
			this.contentLoaded = true;
		}
    }

    handleLoadContent(): void {
        fetch(this.targetToLoad, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'accept-language': this.language,
                // todo: why? if we change to a api controller we don't have this problem...
                'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored
            },
            credentials: 'include'
        })
            .then(response => {
                const contentType = response.headers.get('content-type');
                if (contentType && contentType.includes('text/html')) {
                    return response.text();
                }
            })
            .then(data => {
                this.handleDataContentResult(data);
            });
    }

    private handleDataContentResult(data: string) {
        if (data != null && data.length > 0) {
            this.contentElement.innerHTML = data;
        }
		addClass(this.contentElement,'loaded--content');
		this.contentLoaded = true;
    }

    
}